import { ShadowMCPRequestAccessContent } from "@/components/access/ShadowMCPRequestAccessContent";

export default function ShadowMCPRequestAccess(): JSX.Element {
  return <ShadowMCPRequestAccessContent />;
}
